import { Navigate, Outlet } from 'react-router'
import { useAppSelector } from '~/app/hooks'
import { JsxChildrenProps } from '~/components/GlobalStyles'
import { PATH_NAME } from '~/constants/paths'
import { selectAuth } from '~/redux/features'
import { useLocation } from 'react-router-dom';

const AuthGuard = ({ children }: JsxChildrenProps) => {
  const { token } = useAppSelector(selectAuth)
  const location = useLocation();
  if (!token) {
    const pathAndQuery = location.pathname + location.search;
    window.location.href = PATH_NAME.LOGIN_PAGE.path + (pathAndQuery && pathAndQuery !== '/' ? '?go=' + encodeURIComponent(pathAndQuery) : '')
    return <></>
  }

  return <>{children}</>
}
export const AuthGuardOutlet = () => {
  const { token } = useAppSelector(selectAuth)

  const location = useLocation();
  const pathAndQuery = location.pathname + location.search;
  return (!token ? <Navigate to={PATH_NAME.LOGIN_PAGE.path + (pathAndQuery && pathAndQuery !== '/' ? '?go=' + encodeURIComponent(pathAndQuery) : '')} /> : <Outlet />)
}

export default AuthGuard
